import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './careers-featured-component.component.scss';
import axios from 'axios';
var CareersFeaturedComponent = /** @class */ (function (_super) {
    tslib_1.__extends(CareersFeaturedComponent, _super);
    function CareersFeaturedComponent(element) {
        return _super.call(this, element) || this;
    }
    CareersFeaturedComponent.prototype.init = function () {
        if (this.element.getAttribute('data-site')) {
            this.dataSite = this.element.getAttribute('data-site');
        }
        else {
            this.dataSite = "";
        }
        if (this.element.getAttribute('data-jobs')) {
            this.dataJobs = this.element.getAttribute('data-jobs');
        }
        else {
            this.dataJobs = [];
        }
        if (this.element.getAttribute('data-detail-url')) {
            this.dataDetail = this.element.getAttribute('data-detail-url');
        }
        else {
            this.dataDetail = "";
        }
        this.containerLoader = this.element.querySelector('.careers-featured-component__loader');
        this.containerResults = this.element.querySelector('.careers-featured-component__results');
        this.urlGetJobs = "/sbutils/getFeaturedJobs";
        this.loadJobs();
    };
    CareersFeaturedComponent.prototype.bindEvents = function () {
    };
    CareersFeaturedComponent.prototype.loadJobs = function () {
        var _this = this;
        // variables
        var containerLoader = this.containerLoader;
        var containerResults = this.containerResults;
        var IDs = '';
        var splitted = this.dataJobs.split(",");
        for (var index = 0; index < splitted.length; index++) {
            var element = splitted[index];
            if (index === 0) {
                IDs += element;
            }
            else {
                IDs += '-' + element;
            }
        }
        // generate
        var detail = this.dataDetail;
        var site = this.dataSite;
        // attributes
        var postData = '';
        // date
        var todaysDate = new Date();
        var fullDate = todaysDate.getFullYear().toString() + todaysDate.getMonth().toString() + todaysDate.getDate().toString() + todaysDate.getHours().toString() + todaysDate.getMinutes().toString();
        // variables
        var urlGeneric = this.urlGetJobs + "?time=" + fullDate;
        containerResults.innerHTML = "";
        // service
        axios.get(urlGeneric).then(function (response) {
            var json = response.data;
            var results = json.results;
            results.map(function (job) {
                var date = new Date(job.datePosted).toLocaleDateString();
                var output = "<div class=\"careers-saved-component__result\">\n\t\t\t\t\t<div class=\"careers-saved-component__result--title\">\n\t\t\t\t\t\t<div class=\"careers-saved-component__result--title__link\">\t\n\t\t\t\t\t\t\t<a href=\"" + detail + "?jobID=" + job.jobPostId + "&jobSite=" + site + "&jobLocale=" + job.locale + "\" target=\"_blank\" class=\"title title--module-title\" data-intent=\"navigational\" data-scope=\"careers-featured-component\" data-id=\"link_content\" data-text=\"Job Search | Results | " + job.title + " item click\">" + job.title + "</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"careers-saved-component__result--details\">\n\t\t\t\t\t\t<div class=\"careers-saved-component__result--details__location\">\n\t\t\t\t\t\t\t<strong>" + job.jobLocation[0].name + "</strong>\n\t\t\t\t\t\t</div>\t\n\t\t\t\t\t\t<div class=\"careers-saved-component__result--details__meta\">\n\t\t\t\t\t\t\t<div class=\"careers-saved-component__result--details__meta--dept\">\n\t\t\t\t\t\t\t\t<strong>Career Area</strong>: " + job.FLD_JPM_BUSINESS_LINE + "\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"careers-saved-component__result--details__meta--type\">\n\t\t\t\t\t\t\t\t<strong>Job Type</strong>: " + job.employmentType + "\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\t\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"careers-saved-component__result--description\">\n\t\t\t\t\t\t" + job.description + "\n\t\t\t\t\t</div>\n\t\t\t\t</div>";
                var docFragment = document.createDocumentFragment();
                docFragment.appendChild(document.createRange().createContextualFragment(output));
                _this.containerResults.appendChild(docFragment);
            });
            containerLoader.classList.add('d-none');
            containerResults.classList.remove('d-none');
        }).catch(function (error) {
            console.log(error);
            containerLoader.classList.add('d-none');
        });
    };
    return CareersFeaturedComponent;
}(Base));
export { CareersFeaturedComponent };



//////////////////
// WEBPACK FOOTER
// ./components/careers-featured-component/careers-featured-component.component.ts
// module id = 621
// module chunks = 0